var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-cont pointer",style:(_vm.getStyles)},_vm._l((16),function(idx,index){return _c('img',{staticClass:"flow-item",class:'flow-'+idx,attrs:{"src":_vm.getLuoItem(idx)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }